const t = {
  name: "Hospitality",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15 3H9V5H15V3Z" fill="currentColor"/>
<path d="M4 14V15H2V21H22V15H20V14C20 9.58772 16.4123 6 12 6C7.58772 6 4 9.58772 4 14ZM12 8C15.3077 8 18 10.6923 18 14V15H6V14C6 10.6923 8.69228 8 12 8ZM4 19V17H20V19H4Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Hospitality
};
